"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/base/user");
var _jsMd = _interopRequireDefault(require("js-md5"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: '',
  data: function data() {
    var _this = this;
    return {
      dialogVisible: false,
      loading: false,
      formData: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        currentPassword: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '密码不能少于6位',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '密码不能少于6位',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]+$/,
          message: '密码只能包含字母、数字、下划线',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === _this.formData.currentPassword) {
              callback(new Error('不能与原密码相同'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: '请确认新密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '密码不能少于6位',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.formData.newPassword) {
              callback(new Error('两次输入密码不一致'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
    },
    // 提交表单
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          (0, _user.changePassword)({
            origin_password: (0, _jsMd.default)(_this2.formData.currentPassword),
            password: (0, _jsMd.default)(_this2.formData.newPassword),
            confirmed_password: (0, _jsMd.default)(_this2.formData.confirmPassword)
          }).then(function (res) {
            _this2.$message.success('修改成功');
            _this2.dialogVisible = false;
            _this2.$emit('success');
          }).catch(function (err) {
            console.log('err', err);
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};
exports.default = _default;